<template lang="pug">
el-dialog.resultado-diagnostico(
    :visible.sync='mostrarModal',
    :close-on-click-modal='false',
    :destroy-on-close='true',
    :show-close='false',
    fullscreen
)
    .lista
        .lista__header
            h2.cursor-pointer(@click='mostrarModal = false')
                i.el-icon-arrow-left.voltar
                | Análise Socioambiental
        .lista__content
            .lista__grupo(
                v-for='(grupo, index) in diagnosticoSelecionado.grupo'
            )
                label.font-weight-bold {{ grupo.titulo }}
                div
                    span {{ grupo.nome }}
                DiagnosticoSocioambiental(
                    v-if='refMapa',
                    :dadosConsulta='grupo',
                    :indexCollapse='index',
                    :cpfCnpj='grupo.documento',
                    :habilitar-sinal-aviso='grupo.territorioProximidade',
                    @index-aberto='atualizarRestricaoMapa',
                    :mapaLeaflet='refMapa',
                    :habilitar-opacidade='true',
                    :habilitar-zoom-restricao='true'
                )
    .mapa
        mapa(
            :showStatesLayers='false',
            :mapLayersConfigs='layersMaps',
            :mapConfig='mapConfig',
            :height='"100%"',
            :idMapa='"mapaDetalheAnalise"',
            ref='mapa',
            :atualizarMapa='true'
        )
</template>

<script>
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';
import Mapa from '@/components/MapaLeaflet.vue';

export default {
    name: 'ModalDetalheAnalise',
    components: { Mapa, DiagnosticoSocioambiental },
    data() {
        return {
            mostrarModal: false,
            areasRestricao: [],
            diagnosticoSelecionado: [],
            collapsesAbertos: [],
            layersMaps: [],
            mapConfig: {
                controls: {
                    drawControl: false,
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    buscarCarControl: false,
                    bufferControl: false,
                    uploadFileControl: false
                },
                inspecionar: false,
                diagnostico: false
            },
            refMapa: null
        };
    },
    methods: {
        atualizarRestricaoMapa(restricao, indexGrupo, indexCamada) {
            this.areasRestricao = [];

            /**
             * Remove o último quando for dentro do mesmo collapse
             */
            const mesmogGrupo = this.collapsesAbertos.find(
                c => c.indexGrupo === indexGrupo
            );
            if (mesmogGrupo) {
                this.layersMaps = this.layersMaps.filter(
                    l => l.tagRestricao !== mesmogGrupo.tag
                );
                this.collapsesAbertos = this.collapsesAbertos.filter(
                    l => l.tag !== mesmogGrupo.tag
                );
            }

            /**
             * Quando possuir indexCamada é por que o collapse está sendo aberto
             * Nesse caso a geometria é adicionada no mapa
             */
            if (indexCamada !== '') {
                const grupoSelecionado =
                    this.diagnosticoSelecionado.grupo[indexGrupo];
                const diagnosticoSelecionado =
                    grupoSelecionado.diagnosticos ||
                    grupoSelecionado.diagnostico;
                this.areasRestricao = {
                    areas: diagnosticoSelecionado[indexCamada].resultados.map(
                        resultado => resultado.geometry || resultado.geometria
                    ),
                    camada: diagnosticoSelecionado[indexCamada].camada
                };

                const tagRestricaoAdd = `${indexGrupo}-${indexCamada}-restricao`;
                this.collapsesAbertos.push({
                    indexGrupo,
                    indexCamada,
                    tag: tagRestricaoAdd
                });

                const group = `grupo-restricoes-${indexGrupo}-${indexCamada}`;
                this.mostrarAreasDiagnosticoNoMapa(
                    tagRestricaoAdd,
                    group,
                    restricao
                );
            }
        },

        abrirModal(diagnosticoProtocolo) {
            this.mostrarModal = true;
            this.layersMaps = [];
            this.areasRestricao = [];
            this.collapsesAbertos = [];
            this.diagnosticoSelecionado = null;

            diagnosticoProtocolo.grupo.forEach(grupo => {
                grupo.diagnostico.forEach(diagnostico => {
                    if (diagnostico.camada.nome === 'Áreas embargadas') {
                        diagnostico.camada.nome = 'Áreas embargadas (IBAMA)';
                    }
                });
            });
            this.diagnosticoSelecionado = diagnosticoProtocolo;

            this.adicionaGeometriasFixasNoMapa(diagnosticoProtocolo);

            const self = this;
            setTimeout(() => {
                self.refMapa = self.$refs.mapa;
            }, 500);
        },

        adicionaGeometriasFixasNoMapa(diagnosticoProtocolo) {
            if (diagnosticoProtocolo.territorioGeometria) {
                this.layersMaps.push({
                    style: getEstiloGeometria('area'),
                    geoJson: diagnosticoProtocolo.territorioGeometria,
                    name: 'territorio'
                });
            }
        },

        mostrarAreasDiagnosticoNoMapa(tagRestricao, group, restricao) {
            const opacidade =
                this.areasRestricao.camada.opacidade >= 0.0
                    ? this.areasRestricao.camada.opacidade / 200
                    : 0.5;
            this.areasRestricao.areas.forEach((area, index) => {
                const layerAreaDiagnostico = {
                    style: {
                        color: 'red',
                        weight: 1,
                        fill: true,
                        opacity: opacidade,
                        fillOpacity: opacidade
                    },
                    name: `AreaDiagnostico ${index}`,
                    tagRestricao,
                    group,
                    geoJson: area
                };

                this.layersMaps.push(layerAreaDiagnostico);
            });
        }
    }
};
</script>

<style lang="scss">
.resultado-diagnostico {
    .lista {
        display: flex;
        flex-direction: column;
        width: 35%;
        gap: 20px;
        max-height: 100vh;
        padding: 20px 10px 20px 20px;

        .lista__header {
            .voltar {
                cursor: pointer;
                margin-right: 10px;
            }

            h2 {
                color: var(--primary-font-color);
            }
        }

        .lista__content {
            display: flex;
            flex-direction: column;
            gap: 20px;
            height: 90vh;
            overflow-y: scroll;
        }

        .lista__grupo {
            label {
                color: var(--primary);
            }
        }
    }

    .mapa {
        width: 100%;
        height: 100vh;
        border-radius: 0;
    }

    .el-dialog__body {
        display: flex;
        padding: initial !important;
    }

    .el-dialog__header {
        padding: initial;
    }
}
</style>
